var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-wrap"},[_c('Nav',{attrs:{"only":""}}),_c('Register',{attrs:{"title":"New to Movingkite"},on:{"login":_vm.login,"login-success":_vm.loginSuccess,"register-success":_vm.registerSuccess}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }